import { Tax } from "./Invoiceable";

export class AdditionalField {
  name: string;
  key: string;
  value: string;

  constructor(name: string, key: string, value: string) {
    this.name = name;
    this.key = key;
    this.value = value;
  }
}

export class Product {
  id: string;
  kind: string;
  code: string;
  description: string;
  price: number;
  company_id: number;
  taxes: Tax[];
  deleted: boolean;
  taxes_withheld : Tax[];
  special_taxable_event?: Object;
  selected_retention?:any;
  selected_tax?:any;
  selected_tax_event?: string
  cost_price?: number
  discount?: number;
  discount_type?: string;
  additional_fields: AdditionalField[] = [];

  constructor(
    id: string,
    code: string,
    description: string,
    price: number,
    company_id: number,
    taxes: Tax[],
    deleted: boolean,
    taxes_withheld? : Tax[],
    special_taxable_event?: Object,
    selected_retention?:any,
    selected_tax?:any,
    selected_tax_event?: string,
    cost_price?: number,
    discount?: number,
    discount_type?: string,
    additional_fields?: AdditionalField[]
  ) {
    this.id = id;
    this.kind = 'simple'
    this.code = code;
    this.description = description;
    this.price = price;
    this.company_id = company_id;
    this.taxes = taxes;
    this.deleted = deleted;
    if(selected_retention){
      this.selected_retention = selected_retention;
    }
    else{
      this.selected_retention = 'na';
    }
    if(selected_tax || selected_tax === 0){
      this.selected_tax = selected_tax;
    }
    else{
      this.selected_tax = 0.21;
    }
    if (taxes_withheld){
      this.taxes_withheld = taxes_withheld;
    }
    else{
      this.taxes_withheld = [];
    }
    if (selected_tax_event){
      this.selected_tax_event = selected_tax_event;
    }
    else{
      this.selected_tax_event = 'N/A';
    }
    this.special_taxable_event = special_taxable_event;
    if (cost_price) {
      this.cost_price = cost_price
    }
    this.discount = discount ?? 0;
    this.discount_type = discount_type ?? 'percentage';
    if (additional_fields) {
      this.additional_fields = additional_fields;
    }
  }
  clone(): Product {
    return new Product(
      this.id,
      this.code,
      this.description,
      this.price,
      this.company_id,
      this.taxes.map(tax => tax),
      this.deleted,
      this.taxes_withheld.map(tax => tax),
      this.special_taxable_event,
      this.selected_retention,
      this.selected_tax,
      this.selected_tax_event,
      this.cost_price,
      this.discount,
      this.discount_type,
      this.additional_fields.map(field => new AdditionalField(field.name, field.key, field.value))
    );
  }
}


export class Field {
  name: string;
  key: string

  constructor(name: string, key: string) {
    this.name = name;
    this.key = key;
  }
}

export class ProductConfiguration {
  company_id: number;
  fields: Field[] = [];

  constructor(company_id: number, fields?: Field[]) {
    this.company_id = company_id;
    if (fields) {
      this.fields = fields;
    }
  }
}